import * as React from 'react';
export var SearchCircle = function SearchCircle(_a) {
  var className = _a.className;
  return React.createElement("svg", {
    className: className,
    width: "16",
    height: "16",
    viewBox: "0 0 48 48"
  }, React.createElement("g", {
    transform: "translate(-1247 -368)"
  }, React.createElement("path", {
    d: "M1271,368c-13.3,0-24,10.7-24,24s10.7,24,24,24s24-10.7,24-24S1284.3,368,1271,368z M1286.4,404.5l-6-6\n      c1.3-1.9,2.1-4.2,2.1-6.6c0-6.3-5.1-11.5-11.5-11.5l0,0c-6.3,0-11.5,5.1-11.5,11.5l0,0c0,6.3,5.1,11.5,11.5,11.5l0,0\n      c2.3,0,4.5-0.7,6.4-2l5.9,6c-3.5,2.8-7.9,4.4-12.4,4.4c-10.9,0-19.8-8.9-19.8-19.8c0-10.9,8.9-19.8,19.8-19.8\n      c10.9,0,19.8,8.9,19.8,19.8C1290.8,396.6,1289.3,401,1286.4,404.5z M1278.3,392c0,4-3.3,7.3-7.3,7.3c-4,0-7.3-3.3-7.3-7.3\n      c0-4,3.3-7.3,7.3-7.3C1275,384.7,1278.3,388,1278.3,392z"
  })));
};